import { put, select, takeLatest } from 'typed-redux-saga';

import { removeParticipantAction, updateParticipant } from '../../../../../pages/call/features/conference/slice';
import { selectIsParticipantListOpen, selectParticipantRenderState } from './selectors';
import { setPageIdx } from './slice';

function* handleParticipantListUpdateSaga() {
    const isParticipantListOpen = yield* select(selectIsParticipantListOpen);

    if (!isParticipantListOpen) {
        return;
    }

    const { currentPageIdx, totalPages } = yield* select(selectParticipantRenderState);

    if (currentPageIdx >= totalPages) {
        yield put(setPageIdx(totalPages - 1));
    }
}

export function* rootParticipantListSaga() {
    yield* takeLatest([updateParticipant, removeParticipantAction], handleParticipantListUpdateSaga);
}
